(function () {
  'use strict';

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function buildStars(rating) {
    var rounded = Math.round(rating || 0);
    var html = '<span class="google-review-card__stars rating" role="img" aria-label="' + rounded + ' von 5 Sternen">';
    html += '<span class="rating-star" style="--rating: ' + rounded + '; --rating-max: 5; --rating-decimal: 0;"></span>';
    html += '</span>';
    return html;
  }

  function buildReviewCard(review) {
    return (
      '<li class="marquee__item">' +
        '<div class="google-review-card">' +
          buildStars(review.rating) +
          '<p class="google-review-card__text text-std">' + escapeHtml(review.text) + '</p>' +
          '<div class="google-review-card__footer">' +
            '<div>' +
              '<p class="google-review-card__author-name h5">' + escapeHtml(review.author_name) + '</p>' +
              '<p class="google-review-card__author-date caption">' + escapeHtml(review.relative_time_description) + '</p>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>'
    );
  }

  function renderReviews(root, place) {
    var reviews = (place && place.reviews) || [];
    var loadingEl = root.querySelector('[data-google-reviews-loading]');
    var fallbackEl = root.querySelector('[data-google-reviews-fallback]');
    var marqueeEl = root.querySelector('[data-google-reviews-marquee]');
    var summaryEl = root.querySelector('[data-google-reviews-summary]');
    var summaryTextEl = root.querySelector('[data-google-reviews-summary-text]');
    var starEl = root.querySelector('[data-google-reviews-star]');
    var attributionEl = root.querySelector('[data-google-reviews-attribution]');
    var attributionLinkEl = root.querySelector('[data-google-reviews-link]');

    if (loadingEl) loadingEl.hidden = true;

    if (!reviews.length) {
      if (fallbackEl) fallbackEl.hidden = false;
      return;
    }

    if (summaryEl && place.rating) {
      summaryEl.hidden = false;
      if (starEl) {
        starEl.style.setProperty('--rating', Math.round(place.rating));
      }
      if (summaryTextEl) {
        var countText = place.user_ratings_total
          ? place.rating.toFixed(1) + ' · ' + place.user_ratings_total + ' Bewertungen bei Google'
          : place.rating.toFixed(1) + ' bei Google';
        summaryTextEl.textContent = countText;
      }
    }

    if (attributionEl && attributionLinkEl) {
      if (place.url) {
        attributionLinkEl.setAttribute('href', place.url);
        attributionEl.hidden = false;
      }
    }

    var repeatCount = Math.max(1, Math.ceil(12 / reviews.length));
    var itemsHtml = '';
    for (var r = 0; r < repeatCount; r++) {
      for (var i = 0; i < reviews.length; i++) {
        itemsHtml += buildReviewCard(reviews[i]);
      }
    }

    var tracks = root.querySelectorAll('[data-google-reviews-track]');
    tracks.forEach(function (track) {
      track.innerHTML = itemsHtml;
    });

    if (marqueeEl) marqueeEl.hidden = false;
  }

  function showFallback(root) {
    var loadingEl = root.querySelector('[data-google-reviews-loading]');
    var fallbackEl = root.querySelector('[data-google-reviews-fallback]');
    if (loadingEl) loadingEl.hidden = true;
    if (fallbackEl) fallbackEl.hidden = false;
  }

  function initSection(root) {
    var placeId = root.dataset.placeId;
    var apiKey = root.dataset.apiKey;

    if (!placeId || !apiKey) {
      showFallback(root);
      return;
    }

    function fetchPlace() {
      try {
        var helperNode = document.createElement('div');
        var service = new google.maps.places.PlacesService(helperNode);
        service.getDetails(
          {
            placeId: placeId,
            fields: ['reviews', 'rating', 'user_ratings_total', 'url']
          },
          function (place, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK && place) {
              renderReviews(root, place);
            } else {
              showFallback(root);
            }
          }
        );
      } catch (err) {
        showFallback(root);
      }
    }

    if (window.google && window.google.maps && window.google.maps.places) {
      fetchPlace();
      return;
    }

    var callbackName = '__googleReviewsInit_' + Math.random().toString(36).slice(2);
    window[callbackName] = function () {
      fetchPlace();
      delete window[callbackName];
    };

    var existingScript = document.querySelector('script[data-google-places-loader]');
    if (existingScript) {
      var checkInterval = setInterval(function () {
        if (window.google && window.google.maps && window.google.maps.places) {
          clearInterval(checkInterval);
          fetchPlace();
        }
      }, 200);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&libraries=places&callback=' + callbackName;
    script.async = true;
    script.setAttribute('data-google-places-loader', 'true');
    script.onerror = function () {
      showFallback(root);
    };
    document.head.appendChild(script);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-google-reviews]').forEach(initSection);
  });
})();
